import { ISetting } from '../../interfaces/isetting';
import { AssetTeam } from '../asset-team';
import { Scenario } from '../scenario';

export class SettingBase {
  SettingId: number;
  ForUID: string | null;
  ScenarioId: number | null;
  AppContext: string;
  AppSubContext: string | null;
  AssetTeamId: number | null;
  SysAdminId: string | null;
  SettingData: string;
  UpdatedDate: Date;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetTeam?: AssetTeam;
  Scenario?: Scenario;

  constructor(item?: ISetting) {
    if (item) {

      this.SettingId = item.SettingId;
      this.ForUID = item.ForUID;
      this.ScenarioId = item.ScenarioId;
      this.AppContext = item.AppContext;
      this.AppSubContext = item.AppSubContext;
      this.AssetTeamId = item.AssetTeamId;
      this.SysAdminId = item.SysAdminId;
      this.SettingData = item.SettingData;
      this.UpdatedDate = item.UpdatedDate ? new Date(item.UpdatedDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}